const productRecommendations = () => ({
  init() {
    this._controller = new AbortController()
    fetch(this.$el.dataset.url, { signal: this._controller.signal })
      .then((res) => res.text())
      .then((text) => {
        const dom = new DOMParser().parseFromString(text, 'text/html')
        const recommendations = dom.querySelector('product-recommendations')

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.$el.innerHTML = recommendations.innerHTML
          requestAnimationFrame(() => {
            window._swat?.initializeActionButtons('product-recommendations')
          })
        }
      })
      .catch((e) => {
        if (e.name !== 'AbortError') console.error(e)
      })
  },

  destroy() {
    this._controller?.abort()
  },
})

export default productRecommendations

window.addEventListener('alpine:init', () => {
  Alpine.data('productRecommendations', productRecommendations)
})
